import { Button } from '@sky-distribution/react-commons-ui';
import styled from 'styled-components';

export const StyledMakeCallButton = styled(Button)`
  width: 100%;
  min-height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;
